import { FC } from 'react';
import { ActionTypes, IPrompt, ISource } from '../../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { AppPrompt } from '../../../store/models/conversation';
import { AnswerLoading } from './AnswerLoading';
import { AnswerMessage } from './AnswerMessage';
import { QueryMessage } from './QueryMessage';

// renders the couple question-answer messages
export interface PromptViewProps {
    prompt: AppPrompt;
    isLastPrompt: boolean;
    onUpdate: (actionType: ActionTypes, prompt: IPrompt) => void;
    onEditQuery: (query: string) => void;
    onSourceClick: (source: ISource) => void;
    onEditingChange?: (isEditing: boolean) => void;
}
export const PromptView: FC<PromptViewProps> = (props: PromptViewProps) => {
    const { prompt, isLastPrompt, onUpdate, onEditQuery, onSourceClick, onEditingChange } = props;

    return (
        <>
            <QueryMessage
                id={prompt.id}
                text={prompt.query ?? ''}
                onUpdate={(text) => {
                    if (text) {
                        onEditQuery(text);
                    }
                }}
                onEditingChange={onEditingChange}
            />
            {prompt.answer ? (
                <AnswerMessage
                    key={'answer_container_' + prompt.id}
                    id={prompt.id}
                    text={prompt.answer}
                    regeneratedAnswers={prompt.regeneratedAnswers}
                    sources={prompt.sources}
                    chainOfThoughts={prompt.chainOfThoughts}
                    attachments={prompt.answerAttachments}
                    submittedAttachments={prompt.submittedAttachments}
                    answerModel={prompt.answerModel}
                    answerOn={prompt.answerOn}
                    plugins={prompt.plugins}
                    feedback={prompt.feedback}
                    isLast={isLastPrompt}
                    onFeedback={(feedback) => {
                        onUpdate(ActionTypes.Feedback, { ...prompt, feedback });
                    }}
                    onRegenerate={() => onUpdate(ActionTypes.RegenerateAnswer, prompt)}
                    onSourceClick={onSourceClick}
                />
            ) : prompt.aborted ? null : (
                <AnswerLoading />
            )}
        </>
    );
};
